import create from 'zustand';

const useTokenStore = create((set) => ({
    Menu: null,
    setMenu: (Menu) => set({ Menu }),
    GoMenu: false,
    setGoMenu: (GoMenu) => set({ GoMenu }),

    Pocket:[],
    setPocket: (newPocket) => set({ Pocket: newPocket }),

    PocketNum:0,
    setPocketNum: (PocketNum) => set({PocketNum}),
}));
 
export default useTokenStore;